import './bootstrap';

import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import Swal from 'sweetalert2';
import TomSelect from 'tom-select';
import Sortable from 'sortablejs';

// Register Alpine plugins
Alpine.plugin(collapse);

window.Alpine = Alpine;
window.Swal = Swal;
window.TomSelect = TomSelect;
window.Sortable = Sortable;

import axios from 'axios';
window.axios = axios;

// Faza 1: zaawansowany widok ładunków BULK (Tabulator, ładowany leniwie)
import './bulk-cargo-grid';

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

const initPageTransitions = () => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
        return;
    }

    let navigationPending = false;

    const isDownloadLink = (link) => {
        const href = link.getAttribute('href') || '';
        // Wzorzec po samym adresie jest kruchy: trafia tylko na slowa, ktore ktos
        // wczesniej wymienil. Przez to np. /transport-resources/import-template,
        // /offers/{id}/pdf czy /carriers/template byly przechwytywane jak zwykla
        // nawigacja - tresc znikala, a pobieranie nie wywoluje beforeunload, wiec
        // strona zostawala pusta az do siatki bezpieczenstwa. Stad dwa kryteria.
        // Slowo moze stac po ukosniku ALBO po myslniku: /positioning/template, ale tez
        // /transport-resources/import-template i /registry/export-xlsx. Granica slowa na
        // koncu chroni przed trafieniem w zwykle strony typu /forecast-templates (liczba
        // mnoga), ktore nie sa pobieraniem.
        const downloadPatterns = /[\/-](export|download|pobierz|template|wzor|manifest|print|wydruk|pdf|xlsx|xls|csv)\b/i;
        const fileExtension = /\.(pdf|xlsx|xls|csv|zip|docx?)(\?|#|$)/i;
        return downloadPatterns.test(href) || fileExtension.test(href);
    };

    const shouldSkipLink = (link) => {
        const href = link.getAttribute('href');
        if (!href || href.startsWith('#') || href.startsWith('javascript:')) {
            return true;
        }

        if (link.target && link.target !== '_self') {
            return true;
        }

        if (link.hasAttribute('download') || link.hasAttribute('data-no-transition')) {
            return true;
        }

        if (isDownloadLink(link)) {
            return true;
        }

        const url = new URL(href, window.location.href);
        if (url.origin !== window.location.origin) {
            return true;
        }

        return false;
    };

    const handleLinkClick = (event) => {
        if (event.defaultPrevented || navigationPending) {
            return;
        }

        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
            return;
        }

        const link = event.currentTarget;
        if (shouldSkipLink(link)) {
            return;
        }

        event.preventDefault();
        navigationPending = true;

        const href = link.href;

        window.dispatchEvent(new CustomEvent('page-leave'));

        // Safety net: if the page didn't actually navigate (e.g. unexpected file download),
        // restore visibility after 4 seconds
        let didUnload = false;
        const onBeforeUnload = () => { didUnload = true; };
        window.addEventListener('beforeunload', onBeforeUnload, { once: true });

        window.setTimeout(() => {
            window.location.href = href;
        }, 320);

        window.setTimeout(() => {
            window.removeEventListener('beforeunload', onBeforeUnload);
            if (!didUnload) {
                navigationPending = false;
                window.dispatchEvent(new CustomEvent('page-enter'));
            }
        }, 1200);
    };

    const bindLinks = () => {
        document.querySelectorAll('a[href]').forEach((link) => {
            link.addEventListener('click', handleLinkClick);
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bindLinks, { once: true });
    } else {
        bindLinks();
    }
};

document.addEventListener('alpine:init', initPageTransitions);

/**
 * Sticky table — synchronizacja górnego dummy scrollbara z rzeczywistym
 * scrollem tabeli. Tabele które chcą mieć górny scrollbar muszą mieć
 * markup:
 *
 *   <div class="sticky-table-wrapper">
 *       <div class="sticky-scrollbar-top"><div></div></div>
 *       <div class="sticky-table-scroll"><table>...</table></div>
 *   </div>
 *
 * Funkcja bezpiecznie pomija wrappery bez górnego scrollbara (tylko
 * sticky header bez dummy scrolla).
 */
function initStickyTables() {
    document.querySelectorAll('.sticky-table-wrapper').forEach((wrapper) => {
        const topScroll = wrapper.querySelector('.sticky-scrollbar-top');
        const tableScroll = wrapper.querySelector('.sticky-table-scroll');
        const table = tableScroll?.querySelector('table');

        if (!tableScroll || !table) {
            return;
        }

        // Jeśli nie ma górnego scrollbara — tylko sticky header, nic do sync
        if (!topScroll) {
            return;
        }

        const topInner = topScroll.querySelector('div');
        if (!topInner) {
            return;
        }

        // Ustaw szerokość dummy inner divu aby odzwierciedlał scrollWidth tabeli
        const syncWidth = () => {
            topInner.style.width = table.scrollWidth + 'px';
        };

        syncWidth();

        // Resync przy resize + mutacjach DOM tabeli (np. filtrowanie, sort)
        const resizeObserver = new ResizeObserver(syncWidth);
        resizeObserver.observe(table);

        // Dwukierunkowa synchronizacja scrollLeft
        let isSyncing = false;
        topScroll.addEventListener('scroll', () => {
            if (isSyncing) return;
            isSyncing = true;
            tableScroll.scrollLeft = topScroll.scrollLeft;
            requestAnimationFrame(() => { isSyncing = false; });
        });
        tableScroll.addEventListener('scroll', () => {
            if (isSyncing) return;
            isSyncing = true;
            topScroll.scrollLeft = tableScroll.scrollLeft;
            requestAnimationFrame(() => { isSyncing = false; });
        });
    });
}

document.addEventListener('DOMContentLoaded', initStickyTables);
// Re-init po bfcache restore (nowe DOM elementy mogą się pojawić)
window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
        initStickyTables();
    }
});

/**
 * BFCache restore (przycisk Wstecz w przeglądarce).
 *
 * Problem: initPageTransitions() przed nawigacją dispatchuje 'page-leave',
 * który ukrywa <main> (loaded=false). Gdy user klika Wstecz i przeglądarka
 * przywraca stronę z bfcache, Alpine zachowuje stan loaded=false, więc
 * content jest niewidoczny (biała strona). Wymuszamy 'page-enter' by
 * przywrócić widok. event.persisted=true oznacza że to jest bfcache restore.
 */
window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
        window.dispatchEvent(new CustomEvent('page-enter'));
    }
});

/**
 * Fallback dla przeglądarek bez bfcache lub gdy bfcache nie przywrócił
 * stanu: przy popstate (back/forward) również upewnij się że content
 * jest widoczny.
 */
window.addEventListener('popstate', () => {
    window.dispatchEvent(new CustomEvent('page-enter'));
});

Alpine.start();
